module.exports = "<div class=\"ngx-page-refresh\">\n\t<button md-icon-button color=\"primary\" (click)=\"onRefreshPage()\"><i class=\"fa fa-refresh\"></i></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/ngxGrid/ngxRefresh.component.html
// module id = ../../../../../src/app/shared/ngxGrid/ngxRefresh.component.html
// module chunks = main